import { Form, InputNumber, Row, Col, Input } from "antd";
import "../VisorMartillo.css";
import { useEffect } from "react";

export interface PropMargen {
  lab: string;
  margen: number;
  margen_venta: number;
  margen_total: number;
}

const MargenUltimoTrimestre = ({ margenes }: { margenes?: PropMargen | null }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (margenes) {
      form.setFieldsValue(margenes);
    } else {
      form.resetFields();
    }
  }, [margenes, form]);

  return (
    <Form layout='vertical' size='small' form={form}>
      <div style={{ fontWeight: "bold", fontSize: "10px", marginBottom: 1 }}>Margen último trimestre (M.U.T)</div>

      <Row gutter={1} align='top' wrap={false} style={{ marginTop: "-5px" }}>
        <Col xs={9}>
          <Form.Item
            name='lab'
            label={
              <span style={{ fontSize: "9px", marginTop: "2px", fontWeight: "bold" }}>
                {" "}
                <br />
              </span>
            }
            style={{ marginBottom: 14, marginTop: "-8px" }}
          >
            <Input style={{ width: 100, height: 24, fontSize: "9px", marginTop: "-14px", fontWeight: "bold" }} />
          </Form.Item>
        </Col>
        <Col xs={5}>
          <Form.Item
            name='margen'
            label={<span style={{ fontSize: "9px", marginTop: "2px", fontWeight: "bold" }}>M.U.T</span>}
            style={{ marginBottom: 14, marginTop: "-8px" }}
          >
            <InputNumber style={{ width: 50, height: 24, fontSize: "9px", marginTop: "-18px", fontWeight: "bold" }} />
          </Form.Item>
        </Col>

        <Col xs={5}>
          <Form.Item
            name='margen_total'
            label={<span style={{ fontSize: "9px", fontWeight: "bold" }}>M.U.T. + P.P.</span>}
            style={{ marginBottom: 14, marginTop: "-8px" }}
          >
            <InputNumber style={{ width: 50, height: 24, fontSize: "9px", fontWeight: "bold" }} />
          </Form.Item>
        </Col>

        <Col xs={5}>
          <Form.Item
            name='margen_venta'
            label={<span style={{ fontSize: "9px", fontWeight: "bold" }}>M.VENTA</span>}
            style={{ marginBottom: 14, marginTop: "-8px" }}
          >
            <InputNumber style={{ width: 50, height: 24, fontSize: "9px", fontWeight: "bold" }} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default MargenUltimoTrimestre;
